<template>
  <div class="w-full">
    <div class="w-full bg-gray-300 py-1">
      <pbc-button class="-mt-1 float-right bg-orange-300 m-0"
                  @click='$emit("close")'>
        <close />
      </pbc-button>
      <h3 class="text-gray-600 ml-3">{{title}}</h3>
    </div>
    <slot />
  </div>
</template>
<script>
import Close from '@icons/Close.vue';
export default {
  props:{
    title: {
      type: String,
      required: true
    }
  },
  components:{
    Close
  },
  data() {
    return {
    }
  },
  methods:{
  }
}
</script>
